import Footer from "../../components/Footer";
import TopHeader from "../../components/TopHeader";

export default function Illicite() {
  return (
    <>
      <TopHeader btn={true} />
      <div className="container mt-40 mb-80">
        <div className="col-md-8 mx-auto">
          <h2 className="grey500">
            Politique de lutte contre les contenus illicites
          </h2>
          <p className="body mt-14 grey66 bold500">
            <p>Dernière mise à jour : 16/06/2025</p>
          </p>
          <div className="mt-40">
            <ol>
              <h4 className="grey500 mt-40 mb-16">
                <li>RESTRICTIONS D’USAGE</li>
              </h4>
              <p className="body grey66 mb-10 mt-13">
                Twyny (« Nous ») est une plateforme de mise en relation entre
                des prestataires de services (les « Professionnels ») et des
                consommateurs (les « Clients »). Les services proposés en ligne
                par les Professionnels sont donc variés et l’offre de service
                est directement proposée par le Professionnel. La présente
                politique de lutte contre les contenus illicites (la « Politique
                ») décrit les activités qui sont interdites dans l’utilisation
                de nos services.
              </p>
              <p className="body grey66 mb-10 mt-13">
                Tous les termes en majuscules utilisés dans la présente
                Politique sont définis ci- après ou dans les Conditions
                Générales d’Utilisation (CGU) ou de Vente (CGV), dont la
                présente Politique fait intégralement partie.
              </p>

              <p className="body grey66 mb-10 mt-13">
                Les Clients et les Professionnels s’engagent à proscrire les
                comportements suivants sur la Plateforme :{" "}
              </p>
              <ul>
                <li>
                  <p className="body grey66 mb-10 mt-13">
                    Exploitation et abus des enfants : vous ne pouvez pas offrir
                    de biens ou de services, ni publier ou télécharger des
                    documents qui exploitent ou maltraitent des enfants, y
                    compris, mais sans s&#39;y limiter, des images ou des
                    représentations d&#39;abus d&#39;enfants ou d&#39;abus
                    sexuels, ou qui présentent des enfants de manière sexuelle.
                    Vous ne pouvez pas faire travailler illégalement des mineurs
                    pour fournir vos services présentés sur la Plateforme.{" "}
                  </p>
                </li>
                <li>
                  {" "}
                  <p className="body grey66 mb-10 mt-13">
                    Harcèlement, intimidation, diffamation et menaces : aucun
                    comportement susceptible d’être qualifié comme tel n’est
                    autorisé sur la Plateforme ou vis-à-vis des Clients, ni
                    publier ou télécharger des documents qui harcèlent,
                    intimident, diffament ou menacent un Client ou un tiers.
                  </p>
                </li>
                <li>
                  {" "}
                  <p className="body grey66 mb-10 mt-13">
                    Contenu haineux : il est interdit de promouvoir ou tolérer
                    la haine ou la violence à l&#39;encontre de personnes en
                    raison de leur race, de leur origine ethnique, de leur
                    couleur, de leur origine nationale, de leur religion, de
                    leur âge, de leur sexe, de leur orientation sexuelle, de
                    leur handicap, de leur état de santé, ou d&#39;autres formes
                    d&#39;intolérance discriminatoire. Vous ne pouvez pas
                    utiliser la Plateforme pour promouvoir ou soutenir des
                    organisations, des Professionnels ou des tiers qui : (i)
                    encouragent ou cautionnent des comportements haineux ou
                    discriminatoires ; ou (ii) promeuvent la violence.
                  </p>
                </li>

                <li>
                  {" "}
                  <p className="body grey66 mb-10 mt-13">
                    Activités occultes et illégales : il est interdit de
                    proposer des services, publier ou télécharger des documents
                    qui contreviennent, ou qui facilitent ou encouragent des
                    activités qui contreviennent, à la législation applicable en
                    France ou dans le pays depuis lequel vous proposez vos
                    services.
                  </p>
                </li>
                <li>
                  {" "}
                  <p className="body grey66 mb-10 mt-13">
                    Propriété intellectuelle : il est interdit de promouvoir des
                    services, de publier ou de télécharger des contenus qui
                    enfreignent les droits d&#39;auteur, les marques, les
                    brevets ou tout autre droit de propriété intellectuelle d’un
                    tiers.
                  </p>
                </li>
                <li>
                  {" "}
                  <p className="body grey66 mb-10 mt-13">
                    Pratiques malveillantes : il est interdit de corrompre ou
                    tenter de corrompre la Plateforme avec des techniques de
                    phishing, des virus et autres malwares, du scraping, ou
                    toute autre activité susceptible de porter atteinte à
                    l’intégrité et au fonctionnement de la Plateforme.
                  </p>
                </li>

                <p className="body grey66 mb-10 mt-13">
                  Aucun téléchargement ou distribution de matériaux qui nuisent
                  ou perturbent le fonctionnement de la Plateforme ou
                  d&#39;autres services et infrastructures de Twyny ou de tiers
                  n&#39;est autorisé.
                </p>

                <li>
                  <p className="body grey66 mb-10 mt-13">
                    Pratiques trompeuses et faux engagements : vous ne pouvez
                    pas utiliser les services pour des pratiques commerciales
                    trompeuses ou toute autre activité illicite ou déloyale. Les
                    contributions doivent refléter une expérience réellement
                    vécue chez un Professionnel. Le faux engagement n&#39;est
                    pas autorisé et sera supprimé, de même que tout contenu
                    analysé comme de la désinformation, de l’usurpation
                    d’identité, du dénigrement ou des déclarations trompeuses ou
                    déceptives.
                  </p>
                </li>
                <li>
                  <p className="body grey66 mb-10 mt-13">
                    Informations personnelles, confidentielles ou protégées :
                    vous êtes responsable des données et informations publiées
                    sur votre page de Professionnel. Il est donc de votre
                    responsabilité d’assurer la protection et la confidentialité
                    des données relatives aux Clients ou à des tiers, sur
                    lesquelles vous n’avez pas de droit ou ne bénéficiez pas
                    d’une autorisation de diffusion.
                  </p>
                </li>
                <li>
                  <p className="body grey66 mb-10 mt-13">
                    Prestations, services ou produits soumis à des restrictions
                    légales ou réglementaires : vous devez nécessairement
                    respecter le cadre légal ou réglementaire applicable lorsque
                    vous proposez ce type de prestations, services ou produits.
                    Twyny pourra vous demander de fournir tout document et
                    information attestant de votre conformité à ces exigences
                    légales ou réglementaires.
                  </p>
                </li>
                <li>
                  <p className="body grey66 mb-10 mt-13">
                    Spam et qualité de l’information : vous ne pouvez publier
                    que du contenu basé sur votre expérience ou des questions
                    sur l&#39;expérience des utilisateurs dans un établissement
                    spécifique. Le contenu constitué de commentaires personnels
                    ou d&#39;ordre général, politique ou social n’est pas
                    autorisé. Vous ne pouvez pas utiliser la Plateforme pour
                    transmettre des messages électroniques commerciaux non
                    sollicités, ou plus généralement tout message publicitaire
                    ou de sollicitation. Enfin, la publication de contenu
                    répétitif ou vide de sens est prohibée dans la mesure où
                    cela dilue les informations utiles fournies aux
                    utilisateurs.
                  </p>
                </li>
                <li>
                  <p className="body grey66 mb-10 mt-13">
                    Lutte contre le blanchiment d’argent et le financement du
                    terrorisme : il est interdit de proposer des services ou
                    promouvoir des contenus qui impliquent ou encouragent le
                    soutien, le financement ou l&#39;adhésion à une organisation
                    terroriste, ou au blanchiment de fonds.
                  </p>
                </li>
              </ul>
              <h4 className="grey500 mt-40 mb-16">
                <li>CONTREFACON ET PROPRIETE INTELLECTUELLE</li>
              </h4>
              <p className="body grey66 mb-10 mt-13">
                Twyny encourage la protection de la propriété intellectuelle et
                la présente Politique interdit la publication ou la mise en
                ligne de contenu violant le droit d’auteur, les marques ou la
                propriété intellectuelle de tiers.
              </p>

              <p className="body grey66 mb-10 mt-13">
                La propriété intellectuelle couvre les œuvres matérielles et
                immatérielles, telles que les livres, textes, codes, images,
                vidéos, logos et slogans, dès lors qu’elles résultent d’une
                activité créatrice. Les Professionnels sont invités à protéger
                leur propriété intellectuelle et s’assurer qu’ils ne violent pas
                celle de quelqu’un d’autre.
              </p>

              <p className="body grey66 mb-10 mt-13">
                Le/la propriétaire du droit d’auteur détient les droits
                exclusifs de copier, afficher, distribuer, vendre ou exécuter
                ses œuvres, ou de créer des œuvres dérivées. Un(e) propriétaire
                de droits d’auteur contrôle l’utilisation de ses œuvres, et
                d’autres personnes qui souhaitent utiliser leurs œuvres doivent
                obtenir leur autorisation. Si quelqu’un utilise des œuvres
                protégées sans l’autorisation de son/sa propriétaire, il se peut
                qu’il/elle enfreigne le droit d’auteur.
              </p>

              <p className="body grey66 mb-10 mt-13">
                Les marques protègent les logos ou les dénominations qui
                identifient et distinguent une entreprise ou ses produits /
                services. Une fois enregistrée, une marque bénéficie de
                certaines protections en vertu de la loi, et son titulaire
                détient les droits exclusifs d’utiliser la marque revendiquée
                pour certains produits ou services. Si quelqu’un utilise une
                marque sans autorisation d’une manière qui prête à confusion
                quant à la marque, les produits ou les services, il est possible
                qu’il se rende coupable de contrefaçon.
              </p>

              <h4 className="grey500 mt-40 mb-16">
                <li>NOTIFICATION DE CONTENU ILLICITE</li>
              </h4>
              <p className="body grey66 mb-10 mt-13">
                Twyny a pour politique de répondre promptement aux notifications
                de contenu illicite, conformément à ses obligations posées par
                le DSA (Règlement (UE) 2022/2065 du Parlement européen et du
                Conseil du 19 octobre 2022 relatif à un marché unique des
                services numériques et modifiant la directive 2000/31/CE).
              </p>
              <p className="body grey66 mb-10 mt-13">
                Nous attendons des Professionnels et Utilisateurs qu&#39;ils se
                conforment à la réglementation applicable. Ainsi, si nous
                recevons un avis pertinent indiquant un contenu ou une
                prestation illicite, notre réponse pourra consister en :
              </p>
              <ul>
                <li>
                  <p className="body grey66 mb-10 mt-13">
                    La suspension temporaire du contenu litigieux ;
                  </p>
                </li>

                <li>
                  <p className="body grey66 mb-10 mt-13">
                    La suspension temporaire du Compte de l’Utilisateur ;
                  </p>
                </li>

                <li>
                  <p className="body grey66 mb-10 mt-13">
                    La suppression définitive du contenu litigieux ou du Compte
                    de l’Utilisateur.
                  </p>
                </li>
                <p className="body grey66 mb-10 mt-13">
                  Toute notification de violation ou d’atteinte doit comporter
                  les informations suivantes :
                </p>

                <li>
                  <p className="body grey66 mb-10 mt-13">
                    Vos coordonnées, y compris votre nom complet ou votre
                    dénomination sociale, et votre adresse de courrier
                    électronique.
                  </p>
                </li>
                <li>
                  <p className="body grey66 mb-10 mt-13">
                    L&#39;identification du contenu litigieux de la manière la
                    plus précise possible, en indiquant notamment l’URL ou les
                    URL exact.
                  </p>
                </li>
                <li>
                  <p className="body grey66 mb-10 mt-13">
                    Les liens vers le contenu qui vous paraît violer ou
                    enfreindre vos droits de propriété intellectuelle sur Twyny
                    ou être illicite. Fournissez une liste complète de chaque
                    page avec le contenu que vous souhaitez voir supprimé.
                  </p>
                </li>
                <li>
                  <p className="body grey66 mb-10 mt-13">
                    Une explication suffisamment étayée des raisons pour
                    lesquelles vous considérez que les informations en question
                    sont du contenu illicite ;
                  </p>
                </li>
                <li>
                  <p className="body grey66 mb-10 mt-13">
                    Les déclarations suivantes :
                  </p>
                </li>
                <p className="body grey66 mb-10 mt-13">
                  - (uniquement en cas de violation de droit de propriété
                  intellectuelle) J&#39;estime en toute bonne foi que le/la
                  propriétaire du droit d’auteur, son représentant ou la loi
                  n’autorisent pas l’utilisation du contenu de la manière citée.
                </p>
                <p className="body grey66 mb-10 mt-13">
                  - (uniquement en cas de violation de droit de propriété
                  intellectuelle) Je soussigné(e) que je suis le/la propriétaire
                  du droit de propriété intellectuelle ou que je suis
                  autorisé(e) à agir au nom du/de la propriétaire d’un droit
                  exclusif qui aurait été enfreint.
                </p>
                <p className="body grey66 mb-10 mt-13">
                  - Je reconnais qu’une copie de cette notification, y compris
                  toutes les coordonnées fournies ci-dessus, peut être remise à
                  la personne qui a publié le contenu faisant l&#39;objet
                  d&#39;un rapport.
                </p>
                <p className="body grey66 mb-10 mt-13">
                  - Je déclare, de bonne foi, que les informations et les
                  allégations contenues dans cette notification sont exactes et
                  complètes.
                </p>

                <li>
                  <p className="body grey66 mb-10 mt-13">
                    Votre signature physique ou électronique.
                  </p>
                </li>

                <p className="body grey66 mb-10 mt-13">
                  Si, en tant que Professionnel, vous êtes visé par une
                  notification de violation, nous vous en informerons par le
                  biais de notre Service Client. Si vous estimez en toute bonne
                  foi que le contenu a été mis hors ligne en raison d’une erreur
                  ou d’une fausse identification, vous pouvez envoyer un
                  contre-avis (contestation de notification) en réponse à
                  l’email de Twyny ou directement à support@twyny.com.
                </p>

                <p className="body grey66 mb-10 mt-13">
                  Si, en tant que Professionnel, vous êtes visé par une
                  notification de violation, nous vous en informerons par le
                  biais de notre Service Client. Si vous estimez en toute bonne
                  foi que le contenu a été mis hors ligne en raison d’une erreur
                  ou d’une fausse identification, vous pouvez envoyer un
                  contre-avis (contestation de notification) en réponse à
                  l’email de Twyny ou directement à support@twyny.com.
                </p>

                <p className="body grey66 mb-10 mt-13">
                  Toute contestation de notification doit comporter les
                  informations suivantes :
                </p>

                <li>
                  <p className="body grey66 mb-10 mt-13">
                    Identification du contenu qui a été retiré ou auquel l’accès
                    a été désactivé, et de l’emplacement où le contenu
                    apparaissait avant qu’il a été retiré ou que son accès a été
                    désactivé ;
                  </p>
                </li>
                <li>
                  <p className="body grey66 mb-10 mt-13">
                    Vos nom, adresse et numéro de téléphone ;
                  </p>
                </li>
                <li>
                  <p className="body grey66 mb-10 mt-13">
                    La déclaration suivante :
                  </p>
                </li>

                <p className="body grey66 mb-10 mt-13">
                  - Je reconnais qu’une copie de la présente contestation pourra
                  être transmise à qui de droit pour le traitement de la
                  réclamation.
                </p>

                <p className="body grey66 mb-10 mt-13">
                  Vous pouvez répondre au courriel du service client Twyny et
                  lui adresser toutes vos questions éventuelles.
                </p>
              </ul>

              <h4 className="grey500 mt-40 mb-16">
                <li>CONSEQUENCES DU NON-RESPECT DE LA PRESENTE POLITIQUE</li>
              </h4>

              <p className="body grey66 mb-10 mt-13">
                Tout comportement, activité ou contenu que nous estimons
                contraire à la présente Politique pourra être suspendu
                temporairement ou supprimé définitivement, à tout moment et sans
                préavis. En fonction de la gravité du comportement contrevenant,
                nous nous réservons la possibilité de suspendre votre accès à la
                Plateforme, à votre compte ou aux services Twyny en général.
              </p>
              <p className="body grey66 mb-10 mt-13">
                Conformément aux exigences réglementaires, nous pourrons
                suspendre l&#39;accès à Twyny pour tout utilisateur identifié
                comme fournissant de manière répétée des contenus manifestement
                illicites, y compris ceux décrits dans les sections 1 et 2 de la
                présente politique.
              </p>
              <p className="body grey66 mb-10 mt-13">
                Après avertissement, nous pourrons également suspendre, pour une
                période raisonnable, le traitement des notifications et
                réclamations, des utilisateurs soumettent fréquemment des
                notifications ou des réclamations manifestement infondées.
              </p>
              <p className="body grey66 mb-10 mt-13">
                Twyny a le droit de surveiller ou d&#39;enquêter sur les
                contenus et l’utilisation qui est faite des services, à tout
                moment et à sa discrétion, pour vérifier le respect de la
                présente Politique et des CGU/CGV, ou à tout autre accord
                régissant votre relation avec Twyny ou l’utilisation des
                services. Toute action prise dans le cadre de l&#39;application
                de la présente Politique, y compris le fait de ne prendre aucune
                mesure, sera à notre seule discrétion.
              </p>
              <p className="body grey66 mb-10 mt-13">
                Suite à une décision de Twyny, nous vous informerons de la
                décision prise, qu&#39;il s&#39;agisse de la suppression ou
                restriction de votre contenu, en précisant les raisons
                spécifiques liées à la non-conformité de votre contenu ou de
                votre comportement avec documents règles ou la loi. Nous
                détaillerons les faits et circonstances ayant mené à cette
                décision et vous communiquerons les voies de recours disponibles
                pour contester cette décision.
              </p>
              <p className="body grey66 mb-10 mt-13">
                Vous bénéficiez de la possibilité de contester la décision en
                nous contactant par email à support@twyny.com.
              </p>
              <p className="body grey66 mb-10 mt-13">
                Toute contestation de notification doit comporter les
                informations suivantes :
              </p>

              <ul>
                <li>
                  <p className="body grey66 mb-10 mt-13">
                    Identification de la mesure prise par Twyny (par exemple :
                    retrait ou désactivation de contenu, suspension de compte),
                    et du contenu ou du compte concerné ;
                  </p>
                </li>
                <li>
                  <p className="body grey66 mb-10 mt-13">
                    Vos nom, adresse et numéro de téléphone ;
                  </p>
                </li>
              </ul>
              <h4 className="grey500 mt-40 mb-16">
                <li>
                  INFORMATION DES CONSOMMATEURS EN CAS DE SERVICES ILLEGAUX
                </li>
              </h4>

              <p className="body grey66 mb-10 mt-13">
                Dans l’hypothèse où un professionnel propose des services
                illégaux via Twyny, nous pourrons également notifier les
                consommateurs concernés par l’achat du service sur les
                informations suivantes :
              </p>
              <ul>
                <li>
                  <p className="body grey66 mb-10 mt-13">
                    La confirmation que le service acquis était illégal.
                  </p>
                </li>

                <li>
                  <p className="body grey66 mb-10 mt-13">
                    L&#39;identité complète du professionnel concerné.
                  </p>
                </li>

                <li>
                  <p className="body grey66 mb-10 mt-13">
                    Les informations relatives aux voies de recours disponibles.
                  </p>
                </li>

                <p className="body grey66 mb-10 mt-13">
                  Cette notification pourra se faire :
                </p>

                <li>
                  <p className="body grey66 mb-10 mt-13">
                    Directement si nous disposons des coordonnées des
                    consommateurs ;
                  </p>
                </li>

                <li>
                  <p className="body grey66 mb-10 mt-13">
                    Par affichage sur notre site internet, si nous ne disposons
                    pas des coordonnées de tous les consommateurs concernés.
                  </p>
                </li>
              </ul>
              <h4 className="grey500 mt-40 mb-16">
                <li>INFORMATIONS SUR LA PRESENTE POLITIQUE</li>
              </h4>

              <p className="body grey66 mb-10 mt-13">
                Twyny peut modifier la présente Politique à tout moment en
                publiant une version révisée.
              </p>
              <p className="body grey66 mb-10 mt-13">
                En continuant à utiliser la Plateforme, les services Twyny ou à
                accéder à votre compte après la publication d&#39;une version
                révisée de la Politique, vous acceptez sans réserve les
                modifications apportées.
              </p>
              <p className="body grey66 mb-10 mt-13">
                La présente Politique fait partie intégrante de l’accord
                contractuel qui vous lie à Twyny, qui primera en cas de
                contradiction.
              </p>
              <p className="body grey66 mb-10 mt-13">
                Si vous pensez qu&#39;un utilisateur des services a violé la
                présente Politique, veuillez nous contacter à l&#39;adresse
                support@twyny.com.
              </p>
            </ol>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
